/**
 * Removes HTML tags from a string.
 * @param {string} text - The text from which to remove HTML tags.
 * @returns {string} - The text without HTML tags.
 */
export default (text) => text.replace(/<.*?>.*?<\/.*?>/g, '');
